export default {
  // Default variant
  //-------------------------------------------------------------------------
  default: {
    container: "w-full",
    containerHorizontal: "flex flex-row",
    containerError: "border-error",
    label: "block text-sm font-medium text-text mb-2",
    required: "text-error ml-1",
    optionsContainer: "space-y-3",
    optionsContainerHorizontal: "flex flex-row gap-6 items-center",
    option:
      "flex items-start gap-3 cursor-pointer transition-all duration-200 p-2 rounded-lg hover:bg-neutral_1/50",
    optionSelected: "bg-primary/5",
    optionUnselected: "",
    optionEnabled: "cursor-pointer",
    optionDisabled: "cursor-not-allowed opacity-50",
    optionSmall: "p-1.5 gap-2",
    optionLarge: "p-3 gap-4",
    checkboxWrapper: "",
    optionDescription: "text-xs text-text_secondary mt-1 block",
    errorText: "mt-2 text-sm text-error",
  },

  // Compact variant
  //-------------------------------------------------------------------------
  compact: {
    container: "w-full",
    containerHorizontal: "flex flex-row",
    containerError: "border-error",
    label: "block text-xs font-medium text-text mb-1.5",
    required: "text-error ml-1",
    optionsContainer: "space-y-2",
    optionsContainerHorizontal: "flex flex-row gap-4 items-center",
    option:
      "flex items-start gap-2 cursor-pointer transition-all duration-200 p-1.5 rounded-md hover:bg-neutral_1/50",
    optionSelected: "bg-primary/5",
    optionUnselected: "",
    optionEnabled: "cursor-pointer",
    optionDisabled: "cursor-not-allowed opacity-50",
    optionSmall: "p-1 gap-1.5",
    optionLarge: "p-2 gap-3",
    radioWrapper: "relative flex items-center justify-center mt-0.5",
    radioInput: "sr-only",
    radio:
      "w-4 h-4 border-2 border-neutral_2 rounded-full transition-all duration-200 bg-white",
    radioSelected: "border-primary bg-primary",
    radioUnselected: "border-neutral_2 bg-white hover:border-primary/50",
    radioEnabled: "",
    radioDisabled: "bg-neutral_1 border-neutral_2",
    radioSmall: "w-3.5 h-3.5",
    radioLarge: "w-5 h-5",
    radioIndicator: "w-1.5 h-1.5 bg-white rounded-full",
    labelWrapper: "flex-1",
    optionLabel: "text-xs font-medium text-text",
    optionDescription: "text-xs text-text_secondary mt-0.5 block",
    errorText: "mt-1.5 text-xs text-error",
  },

  // Large variant
  //-------------------------------------------------------------------------
  large: {
    container: "w-full",
    containerHorizontal: "flex flex-row",
    containerError: "border-error",
    label: "block text-base font-medium text-text mb-3",
    required: "text-error ml-1",
    optionsContainer: "space-y-4",
    optionsContainerHorizontal: "flex flex-row gap-8 items-center",
    option:
      "flex items-start gap-4 cursor-pointer transition-all duration-200 p-3 rounded-lg hover:bg-neutral_1/50",
    optionSelected: "bg-primary/5",
    optionUnselected: "",
    optionEnabled: "cursor-pointer",
    optionDisabled: "cursor-not-allowed opacity-50",
    optionSmall: "p-2 gap-3",
    optionLarge: "p-4 gap-5",
    radioWrapper: "relative flex items-center justify-center mt-0.5",
    radioInput: "sr-only",
    radio:
      "w-6 h-6 border-2 border-neutral_2 rounded-full transition-all duration-200 bg-white",
    radioSelected: "border-primary bg-primary",
    radioUnselected: "border-neutral_2 bg-white hover:border-primary/50",
    radioEnabled: "",
    radioDisabled: "bg-neutral_1 border-neutral_2",
    radioSmall: "w-5 h-5",
    radioLarge: "w-7 h-7",
    radioIndicator: "w-2.5 h-2.5 bg-white rounded-full",
    labelWrapper: "flex-1",
    optionLabel: "text-base font-medium text-text",
    optionDescription: "text-sm text-text_secondary mt-1 block",
    errorText: "mt-2 text-sm text-error",
  },

  // Admin variant (for admin interface)
  //-------------------------------------------------------------------------
  admin: {
    container: "w-full",
    containerHorizontal: "flex flex-row",
    containerError: "border-admin_error",
    label: "block text-sm font-medium text-admin_text mb-2",
    required: "text-admin_error ml-1",
    optionsContainer: "space-y-3",
    optionsContainerHorizontal: "flex flex-row gap-6 items-center",
    option:
      "flex items-start gap-3 cursor-pointer transition-all duration-200 p-2 rounded-lg hover:bg-admin_neutral_1/30",
    optionSelected: "bg-admin_primary/5",
    optionUnselected: "",
    optionEnabled: "cursor-pointer",
    optionDisabled: "cursor-not-allowed opacity-50",
    optionSmall: "p-1.5 gap-2",
    optionLarge: "p-3 gap-4",
    checkboxWrapper: "",
    optionDescription: "text-xs text-admin_text_secondary mt-1 block",
    errorText: "mt-2 text-sm text-admin_error",
  },

  // Card variant (options look like cards)
  //-------------------------------------------------------------------------
  card: {
    container: "w-full",
    containerHorizontal: "flex flex-row",
    containerError: "border-error",
    label: "block text-sm font-medium text-text mb-3",
    required: "text-error ml-1",
    optionsContainer: "space-y-3",
    optionsContainerHorizontal: "grid grid-cols-2 gap-3",
    option:
      "flex items-start gap-3 cursor-pointer transition-all duration-200 p-4 rounded-lg border-2 hover:shadow-md",
    optionSelected: "bg-primary/5 border-primary shadow-sm",
    optionUnselected: "bg-white border-neutral_1 hover:border-primary/30",
    optionEnabled: "cursor-pointer",
    optionDisabled: "cursor-not-allowed opacity-50 bg-neutral_1",
    optionSmall: "p-3 gap-2",
    optionLarge: "p-5 gap-4",
    radioWrapper: "relative flex items-center justify-center mt-0.5",
    radioInput: "sr-only",
    radio:
      "w-5 h-5 border-2 border-neutral_2 rounded-full transition-all duration-200 bg-white",
    radioSelected: "border-primary bg-primary",
    radioUnselected: "border-neutral_2 bg-white",
    radioEnabled: "",
    radioDisabled: "bg-neutral_1 border-neutral_2",
    radioSmall: "w-4 h-4",
    radioLarge: "w-6 h-6",
    radioIndicator: "w-2 h-2 bg-white rounded-full",
    labelWrapper: "flex-1",
    optionLabel: "text-sm font-medium text-text",
    optionDescription: "text-xs text-text_secondary mt-1 block",
    errorText: "mt-3 text-sm text-error",
  },

  // Admin card variant
  //-------------------------------------------------------------------------
  admin_card: {
    container: "w-full",
    containerHorizontal: "flex flex-row",
    containerError: "border-admin_error",
    label: "block text-sm font-medium text-admin_text mb-3",
    required: "text-admin_error ml-1",
    optionsContainer: "space-y-3",
    optionsContainerHorizontal: "grid grid-cols-2 gap-3",
    option:
      "flex items-start gap-3 cursor-pointer transition-all duration-200 p-4 rounded-lg border-2 hover:shadow-md",
    optionSelected: "bg-admin_primary/5 border-admin_primary shadow-sm",
    optionUnselected:
      "bg-admin_paper border-admin_neutral_1 hover:border-admin_primary/30",
    optionEnabled: "cursor-pointer",
    optionDisabled: "cursor-not-allowed opacity-50 bg-admin_canvas",
    optionSmall: "p-3 gap-2",
    optionLarge: "p-5 gap-4",
    radioWrapper: "relative flex items-center justify-center mt-0.5",
    radioInput: "sr-only",
    radio:
      "w-5 h-5 border-2 border-admin_neutral_1 rounded-full transition-all duration-200 bg-admin_paper",
    radioSelected: "border-admin_primary bg-admin_primary",
    radioUnselected: "border-admin_neutral_1 bg-admin_paper",
    radioEnabled: "",
    radioDisabled: "bg-admin_canvas border-admin_neutral_1",
    radioSmall: "w-4 h-4",
    radioLarge: "w-6 h-6",
    radioIndicator: "w-2 h-2 bg-white rounded-full",
    labelWrapper: "flex-1",
    optionLabel: "text-sm font-medium text-admin_text",
    optionDescription: "text-xs text-admin_text_secondary mt-1 block",
    errorText: "mt-3 text-sm text-admin_error",
  },

  // Minimal variant (no borders, simple styling)
  //-------------------------------------------------------------------------
  minimal: {
    container: "w-full",
    containerHorizontal: "flex flex-row",
    containerError: "",
    label: "block text-sm font-medium text-text mb-2",
    required: "text-error ml-1",
    optionsContainer: "space-y-2",
    optionsContainerHorizontal: "flex flex-row gap-6 items-center",
    option: "flex items-start gap-3 cursor-pointer transition-all duration-200",
    optionSelected: "",
    optionUnselected: "",
    optionEnabled: "cursor-pointer",
    optionDisabled: "cursor-not-allowed opacity-50",
    optionSmall: "gap-2",
    optionLarge: "gap-4",
    radioWrapper: "relative flex items-center justify-center mt-0.5",
    radioInput: "sr-only",
    radio:
      "w-5 h-5 border-2 border-neutral_2 rounded-full transition-all duration-200 bg-white",
    radioSelected: "border-primary bg-primary",
    radioUnselected: "border-neutral_2 bg-white hover:border-primary/50",
    radioEnabled: "",
    radioDisabled: "bg-neutral_1 border-neutral_2",
    radioSmall: "w-4 h-4",
    radioLarge: "w-6 h-6",
    radioIndicator: "w-2 h-2 bg-white rounded-full",
    labelWrapper: "flex-1",
    optionLabel: "text-sm font-medium text-text",
    optionDescription: "text-xs text-text_secondary mt-1 block",
    errorText: "mt-2 text-sm text-error",
  },
}
